import { GiftChoiceUnitData } from '@shared/api/giftChoiceUnit/giftChoiceUnit.interface';
import { GiftItemBrand } from '@shared/api/giftItemBrand/giftItemBrand.interface';
import { Image } from '@shared/api/media/media.interface';
import { QueryDataState } from '@shared/interfaces';

// Enum
export enum GiftItemInfoType {
  Delivery = 'Delivery', // 배송형
  Coupon = 'Coupon', // 쿠폰형
}

// 쿠폰 상세 정보
export type CouponDetail = {
  validPeriod: string; // 유효기간
  placeOfExchange: string; // 교환처
};

// GiftItemInfo (원상품 정보 - Admin 관리)
export type GiftItemInfo<
  TImage = string,
  THeaderImages = string[],
  TDetailImages = string[],
  TDeliveredImageList = string[],
  TGiftItemBrand = string,
  TChoiceUnits = string[],
> = {
  _id: string;
  type: GiftItemInfoType;
  giftItemBrand?: TGiftItemBrand; // 상품 브랜드 (예: 스타벅스)
  name: string;
  image?: TImage; // 대표 이미지 (목록 썸네일)
  headerImages: THeaderImages; // 상세페이지 상단 carousel 이미지들 (정사각형)
  detailImages: TDetailImages; // 상세 이미지 (세로로 이어붙임)
  deliveredImageList: TDeliveredImageList;
  detailInfo: string;
  priceRegular: number; // 정가
  priceRetail: number; // 판매가
  priceWhole: number; // 도매가
  isEnabled: boolean;
  isSelectable: boolean; // 선택형 상품 여부
  choiceUnits: TChoiceUnits; // 선택 가능 유닛 목록
  couponDetail?: CouponDetail; // 쿠폰형일 때 사용
  minOrderQuantity: number; // 최소주문수량
  orderUnit: number; // 주문단위
  order?: number; // 기본 표시 순서 (낮을수록 앞, 없으면 맨 뒤)
  tags: string[];
  createdAt: Date;
  updatedAt: Date;
};

// 타입 별칭
export type GiftItemInfoData = GiftItemInfo<
  Image,
  Image[],
  Image[],
  Image[],
  GiftItemBrand,
  GiftChoiceUnitData[]
>;
export type GiftItemInfoListData = GiftItemInfoData[];

// State 타입
export type GiftItemInfoState = QueryDataState<GiftItemInfoData>;
export type GiftItemInfoListState = QueryDataState<GiftItemInfoListData>;

// Create/Update 타입
export type GiftItemInfoCreate = {
  type: GiftItemInfoType;
  giftItemBrand?: string; // 상품 브랜드 ID
  name: string;
  image?: string;
  headerImages?: string[];
  detailImages?: string[];
  deliveredImageList?: string[];
  detailInfo?: string;
  priceRegular?: number;
  priceRetail?: number;
  priceWhole: number;
  isEnabled: boolean;
  isSelectable?: boolean; // 선택형 상품 여부
  choiceUnits?: string[]; // 선택 가능 유닛 ID 목록
  couponDetail?: CouponDetail;
  minOrderQuantity?: number;
  orderUnit?: number;
  order?: number; // 기본 표시 순서
  tags?: string[];
};

export type GiftItemInfoUpdate = {
  _id: string;
  type?: GiftItemInfoType;
  giftItemBrand?: string | null; // 상품 브랜드 ID (null로 설정하면 제거)
  name?: string;
  image?: string;
  headerImages?: string[];
  detailImages?: string[];
  deliveredImageList?: string[];
  detailInfo?: string;
  priceRegular?: number;
  priceRetail?: number;
  priceWhole?: number;
  isEnabled?: boolean;
  isSelectable?: boolean; // 선택형 상품 여부
  choiceUnits?: string[]; // 선택 가능 유닛 ID 목록
  couponDetail?: CouponDetail;
  minOrderQuantity?: number;
  orderUnit?: number;
  order?: number; // 기본 표시 순서
  tags?: string[];
};
